const React = require("react");
import { ThemeProvider } from "styled-components";
import { Reset } from "styled-reset";
import theme from "./theme";
export default (props) => /* @__PURE__ */ React.createElement(ThemeProvider, {
  theme
}, /* @__PURE__ */ React.createElement(Reset, null), props.children);
